import React, {useState, useEffect, useCallback} from 'react';
import * as TreeAcross from './Common/TreeAcross';
import { SortableTreeWithoutDndContext as SortableTree } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import './IntentTree.css';
import AnswerContainer from './AnswerContainer';
import * as SizeFunctions from './SizeFunctions';
import DragAndDrop from './DragAndDrop';

function App(props) {

  var treeVIn = props.tree;
  var position = props.position;
  var subtitleStart = props.subtitle;
  var selectPosition = props.selectPosition;
  var positionString = "";
  var ansSetInset = props.ansSetInset;
  var startLevelsArray = props.startLevelsArray;
  var isFunctionMode = props.isFunctionMode;
  var isSubmitting = props.isSubmitting;


  const [showTree, setShowTree] = useState(true);
  const [heightOfInsert, setArrayOfHeights] = useState(0);

  if (position){
    positionString = position.map((aPosition, index)=>{
      return aPosition.v;
    }).join(" ");
  }


  const formTree = useCallback((tree, startLevelsArrayIn)=>{

    function formT(treeV, subtitle, levels, depth){
      var title = treeV.v[1].v;
      var funkyButton = "";
      var erlangTypeID = treeV.v[0].v;
      // var isHead = treeV.v[3].v;
      var labels = treeV.v[4].v;
      var expression = treeV.v[8];
      var children = [];
      var showHere = false;
      var interactionType = TreeAcross.getInteractionType(treeV);

      var pathJoined = levels.join(" ");
      if (pathJoined === positionString && isFunctionMode.v === 0){
      }else{
        if (interactionType === 0 || depth === 0 || isFunctionMode.v === -1){
          showHere = true;
          children = treeV.v[2].v.filter((aChild, index)=>{
            if (isFunctionMode.v === -1){
              var erlangTypeID1 = aChild.v[0].v;
              var expression = aChild.v[8];
              var p = TreeAcross.isAnAddVariable(erlangTypeID1, expression);
              if (p){
                return false;
              }
            }
            return true;
          }).map((aChild, index)=>{
            var thisSubtitle = TreeAcross.getSubtitleFromLabels(index, labels);
              return formT(aChild, thisSubtitle, levels.concat(+index), depth + 1);
            })          
        }
      }

      // var isEditable = treeV.v[6].v;
      var notes = 0;
      if (treeV.v.length > 8){
        var notesSet = treeV.v[8];
        if (notesSet.t === "tuple"){
          if (notesSet.v[0].v === "k"){
            notes = notesSet.v[1].v;
          }
        }
      }

      // if (erlangTypeID === 166){
      //   subtitle = " ";
      // }
      // if (!subtitle){
      //   subtitle = " ";
      // }
      if (title.indexOf("+ ") === 0){
        funkyButton = title;
        title = "";
        subtitle = "";
      }
      return {title, subtitle, funkyButton, children, erlangTypeID, notes, expression, expanded:true, selfPath:levels, showHere};
    }

    return formT(tree, subtitleStart, startLevelsArrayIn, 0);
  }, [subtitleStart, positionString, isFunctionMode]);


  const compareTreeLists = useCallback((newTree, oldTree) =>{
    return newTree.map((aNode, index)=>{
      if (oldTree.length > index){
        var oldNode = oldTree[index];
        if (aNode.erlangTypeID === oldNode.erlangTypeID && aNode.notes === oldNode.notes){
          aNode.children = compareTreeLists(aNode.children, oldNode.children);
          aNode.expanded = oldNode.expanded;          
        }
      }
      return aNode;
    })
  }, []);

  function countTree(treeV){
    var total = 1;
    if (treeV.expanded){
      if (treeV.erlangTypeID === 161 || treeV.erlangTypeID === 180){
        total += 3;
      }
      treeV.children.map((aChild, index)=>{
        var p = countTree(aChild);
        total += p;
        return null;
      })        
    }
    return total;
  }

  var treeDataIn = [formTree(treeVIn, startLevelsArray)];
  const [treeData, setTreeData] = useState(treeDataIn);

  useEffect(() => {
    var newTree = compareTreeLists([formTree(treeVIn, startLevelsArray)], treeData);
    setTreeData(newTree);
    setArrayOfHeights(0);
  }, [treeVIn, formTree, compareTreeLists, position, isFunctionMode]);

  useEffect(() => {
    setShowTree(false);
    setTimeout(function() {
      setShowTree(true);
    }, 0);

  }, [heightOfInsert, treeData, isSubmitting]);


  var numberOfRows = countTree(treeData[0]);

  function clickSelect(extendedNode){
    return function(e){
      selectPosition(extendedNode.node.selfPath);
    }
  }

  function clickRevealHere(extendedNode){
    return function(e){
      selectPosition(extendedNode.node.selfPath.concat([-1]));
    }
  }

  function aClassName(extendedNode){
    var path = extendedNode.node.selfPath;
    var pathJoined = path.join(" ");
    if (pathJoined === positionString){
      return "icon-blue"
    }else{
      var showHere = extendedNode.node.showHere;
      if (!showHere && positionString.indexOf(pathJoined) === 0){
        return "icon-highlight-view"
      }
    }
    return "";
  }

  function buttons(extendedNode){
    var erlangTypeID = extendedNode.node.erlangTypeID;
    if (isFunctionMode.v === -1){
      var expression = extendedNode.node.expression;
      if (expression.t === "tuple"){
        if (expression.v[0].v === "intentTypeVariable" || expression.v[0].v === "r"){
          return [];
        }
      }

      if (!TreeAcross.isValidVariableOrReusable(erlangTypeID, expression)){
        return [];
      }

      return [<button onClick={clickSelect(extendedNode)}>Reuse</button>];
//      

    }else if (isFunctionMode.v === 0){
      if (erlangTypeID === 143){  // inputs 
        return [];
      }else{
        var path = extendedNode.node.selfPath;
        var pathJoined = path.join(" ");
        if (pathJoined === positionString){
            return []
        }else{
          var showHere = extendedNode.node.showHere;
          if (showHere){
            var funkyButton = extendedNode.node.funkyButton;
            if (funkyButton){
              return [<button onClick={clickSelect(extendedNode)}>{funkyButton}</button>];
    //          
            }else{
              return [<button onClick={clickSelect(extendedNode)}>Change</button>];
            }
    //
          }else{
            var pieces = [];
            if (erlangTypeID === 137 || erlangTypeID === 22){  //assignments or expressions.
            }else{
              pieces.push(<button onClick={clickSelect(extendedNode)}>Change</button>)
            }
    //
            if (positionString.indexOf(pathJoined) === 0){
            }else{
              pieces.push(<button onClick={clickRevealHere(extendedNode)}>View</button>)
            }
    //
            return pieces;
          }
        }
      }
    }
//
  }

  function generateProps(extendedNode){
    var path = extendedNode.node.selfPath;
    var pathJoined = path.join(" ");
    var subtitle = extendedNode.node.subtitle;
    var p = {};

    var buttons1 = buttons(extendedNode);
    if (buttons1){
      p.buttons = buttons1;
    }

    var className = aClassName(extendedNode);
    if (isFunctionMode.v === 0){
      if (className){
        p.className = className;
      }
    }
    if (pathJoined === positionString && isFunctionMode.v === 0){
      p.subtitle = <AnswerContainer reportHeight={SizeFunctions.updateSubsetDimensions(setArrayOfHeights)} contents={ansSetInset} subtitle={subtitle}/>
    }else if (subtitle){
      p.subtitle = subtitle;
    }
    return p;
  }
//
  function rowHeight(extendedNode){
    var path = extendedNode.node.selfPath;
    var pathJoined = path.join(" ");
    if (pathJoined === positionString){
      return heightOfInsert + 62;
    }else{
      return 62;
    }

  }

  var inside;
  if (showTree && treeData){
    inside = <DragAndDrop><SortableTree
              treeData={treeData}
              onChange={treeData => setTreeData(treeData)}
              canDrag={false}
              rowHeight={rowHeight}
              generateNodeProps={generateProps}
            /></DragAndDrop>
  }
//  
    return <div style={{ height: 10 + numberOfRows * 62 + heightOfInsert  }} >
              {inside}
          </div>

  
    //
}


export default App;

